module.exports = __webpack_public_path__ + "static/media/card.14d4ca03.svg";